import axios from 'axios'
import CreateCountry from './dto/CreateCountry'
import {EntityDto} from '../../../../../services/dto/entityDto'
import {PagedCountryResultRequestDto} from './dto/PagedCountryResultRequestDto'
import {PagedResultDto} from '../../../../../services/dto/pagedResultDto'
import GetAllCountries from './dto/GetAllCountries'
import UpdateCountry from './dto/UpdateCountry'
import GetCountry from './dto/GetCountry'

const API_URL = process.env.REACT_APP_SERVICE_API_URL
export const URL_CREATE = `${API_URL}/Country/Create`
export const URL_DELETE = `${API_URL}/Country/Delete`
export const URL_GET = `${API_URL}/Country/Get`
export const URL_GET_ALL = `${API_URL}/Country/GetPagedAll`
export const URL_UPDATE = `${API_URL}/Country/Update`

export function onCreateCountry(createCountry: CreateCountry): Promise<boolean> {
  return axios.post(URL_CREATE, createCountry)
}

export function onDeleteCountry(entityDto: EntityDto): Promise<boolean> {
  return axios.delete(URL_DELETE, {params: entityDto})
}

export function onGetCountry(entityDto: EntityDto): Promise<GetCountry> {
  return axios.get(URL_GET, {params: entityDto})
}

export function onGetPagedAllCountries(
  pagedFilterAndSortedRequest: PagedCountryResultRequestDto
): Promise<PagedResultDto<GetAllCountries>> {
  return axios.get(URL_GET_ALL, {params: pagedFilterAndSortedRequest})
}

export function onUpdateCountry(updateCountryInput: UpdateCountry): Promise<boolean> {
  return axios.put(URL_UPDATE, updateCountryInput)
}
